<template>
  <div class="d-flex align-center justify-center">
    <span style="font-size: 80px">404</span>
    <h1>That page doesn't exist!</h1>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class NotFoundView extends Vue {}
</script>

<style scoped></style>
